export default __webpack_public_path__ + "static/media/face_2_24.dde3dda8.png";